import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import AuthViewController from "../redux/actions/AuthViewController";

const ActivationSuccessPage = () => {
  const { activeAccount } = AuthViewController();
  const { uid, token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (uid && token) {
      dispatch(activeAccount({ uid, token }));
    }
  }, [dispatch, uid, token]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f9fafb",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "3rem 4rem",
          borderRadius: "12px",
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        <div style={{ fontSize: "3rem", color: "#28a745" }}>✅</div>
        <h2 style={{ color: "#28a745", marginBottom: "1rem" }}>
          Account Activated Successfully!
        </h2>

        <p style={{ fontSize: "1rem", color: "#555", marginBottom: "1.5rem" }}>
          Your account has been activated. Please check your email for the{" "}
          <strong>reset password</strong> and <strong>onboarding link</strong>.  
          Complete this before logging in.
        </p>

        <button
          onClick={() => navigate("/login")}
          style={{
            backgroundColor: "#28a745",
            color: "#fff",
            padding: "0.75rem 2rem",
            fontSize: "1rem",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default ActivationSuccessPage;
